import { render, staticRenderFns } from "./LaboralDedicationAddEdit.vue?vue&type=template&id=d33c9faa"
import script from "./LaboralDedicationAddEdit.vue?vue&type=script&lang=js"
export * from "./LaboralDedicationAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports